<template>
  <VOtpInput
    ref="vOtpInput"
    data-testid="otp-input"
    input-classes="otp-input"
  />
</template>

<script setup>
import VOtpInput from "vue3-otp-input";

const vOtpInput = ref(null);

defineExpose({
  clearInput: () => {
    unref(vOtpInput).clearInput();
  },
});
</script>

<style lang="scss" scoped>
:deep(.otp-input) {
  width: 30px;
  height: 47px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  line-height: 28px;
  border: 2px solid $primary;
  border-width: 0 0 2px 0;
  text-align: center;

  &:focus-within {
    outline: none;
  }
}

:deep(.otp-input::-webkit-inner-spin-button),
:deep(.otp-input::-webkit-outer-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}
</style>
